import { ReactiveTraderIcon } from "./types"

export const CheckCircleIcon = ({
  width = 16,
  height = 16,
}: ReactiveTraderIcon) => (
  <svg width={width} height={height} viewBox="0 0 14 14" fill="currentColor">
    <path d="M7 13.2709C3.54083 13.2709 0.729164 10.4592 0.729164 7.00008C0.729164 3.54091 3.54083 0.729248 7 0.729248C10.4592 0.729248 13.2708 3.54091 13.2708 7.00008C13.2708 10.4592 10.4592 13.2709 7 13.2709ZM7 1.60425C4.025 1.60425 1.60416 4.02508 1.60416 7.00008C1.60416 9.97508 4.025 12.3959 7 12.3959C9.975 12.3959 12.3958 9.97508 12.3958 7.00008C12.3958 4.02508 9.975 1.60425 7 1.60425Z" />
    <path d="M6.17167 9.08827C6.055 9.08827 5.94417 9.0416 5.8625 8.95993L4.21167 7.3091C4.0425 7.13993 4.0425 6.85993 4.21167 6.69077C4.38083 6.5216 4.66083 6.5216 4.83 6.69077L6.17167 8.03243L9.17 5.0341C9.33917 4.86493 9.61917 4.86493 9.78834 5.0341C9.9575 5.20327 9.9575 5.48327 9.78834 5.65243L6.48083 8.95993C6.39917 9.0416 6.28834 9.08827 6.17167 9.08827Z" />
  </svg>
)
